<div class="container">
  <div class="row">
    <div class="col-11" style="padding-top: 5%">
      <app-breadcrumb category="Wishlist"></app-breadcrumb>
      <h3 style="font-weight: bold">Wishlist</h3>

      <div class="row">
        <div
          class="card col-lg-3 col-md-6 md-1 col-sm-12"
          *ngFor="let product of saved">
          <app-wishlistitem [pid]="product"> </app-wishlistitem>
        </div>
      </div>
    </div>
  </div>
  <div class="row-2 text-center">
    <h3  style="font-family: 'proxima-nova'; font-size: 13px;">Surf for More Product</h3>
    <button routerLink="/productlists/NULL/All Products" class="btn btn-info" style="border-radius: 0px; font-size: 12px; font-family: 'proxima-nova';">View More Product</button>
  </div>
</div>
